export default ($axios) => ({
  fetch(query) {
    return $axios.get('/admin/sms/monitor', { params: query }).then((response) => response.data);
  },
  fetchAnalytics(query) {
    return $axios.get('/admin/sms/monitor/analytics', { params: query }).then((response) => response.data);
  },
});
